import { createSelector } from 'reselect';

const DEFAULT_HIDDEN_COLUMNS = ['start_date', 'created_at', 'reminder', 'story_points', 'tracked_time'];
const DEFAULT_COLLAPSED_GROUPS = ['thisWeek', 'thisMonth', 'other', 'noDueDate'];
const EMPTY_ARRAY = [];

const getVisibleChats = state => state?.team_chats?.visible || EMPTY_ARRAY;
export const makeGetVisibleChats = () => createSelector(getVisibleChats, visibleChats => visibleChats);

const getCollapsedSubteams = state => state?.subteams?.collapsed || EMPTY_ARRAY;
export const makeGetCollapsedSubteams = () => createSelector(getCollapsedSubteams, collapsedSubteams => collapsedSubteams);

const getWorkloadsState = state => state?.workloads;
export const makeGetWorkloadsState = () => createSelector(getWorkloadsState, workloadsState => workloadsState);

const getAllTasksCollapsedGroups = state => state?.allTasks?.tasks?.collapsedGroups || EMPTY_ARRAY;
export const makeGetAllTasksCollapsedGroups = () => createSelector(getAllTasksCollapsedGroups, collapsedGroups => collapsedGroups);

const getAllTasksColumnsOrder = state => state?.allTasks?.tasks?.columns || EMPTY_ARRAY;
export const makeGetAllTasksColumnsOrder = () => createSelector(getAllTasksColumnsOrder, columns => columns);

const getAllTasksHiddenColumns = state => state?.allTasks?.tasks?.hiddenColumns || DEFAULT_HIDDEN_COLUMNS;
export const makeGetAllTasksHiddenColumns = () => createSelector(getAllTasksHiddenColumns, hiddenColumns => hiddenColumns);

const getWorkloadsCollapsedGroups = state => state?.workloads?.tasks?.collapsedGroups || EMPTY_ARRAY;
export const makeGetWorkloadsCollapsedGroups = () => createSelector(getWorkloadsCollapsedGroups, collapsedGroups => collapsedGroups);

const getWorkloadsColumnsOrder = state => state?.workloads?.tasks?.columns || EMPTY_ARRAY;
export const makeGetWorkloadsColumnsOrder = () => createSelector(getWorkloadsColumnsOrder, columns => columns);

const getWorkloadsHiddenColumns = state => state?.workloads?.tasks?.hiddenColumns || DEFAULT_HIDDEN_COLUMNS;
export const makeGetWorkloadsHiddenColumns = () => createSelector(getWorkloadsHiddenColumns, hiddenColumns => hiddenColumns);

const getMyTasksCollapsedGroups = state => state?.myTasks?.tasks?.collapsedGroups || DEFAULT_COLLAPSED_GROUPS;
export const makeGetMyTasksCollapsedGroups = () => createSelector(getMyTasksCollapsedGroups, collapsedGroups => collapsedGroups);

const getMyTasksColumnsOrder = state => state?.myTasks?.tasks?.columns || EMPTY_ARRAY;
export const makeGetMyTasksColumnsOrder = () => createSelector(getMyTasksColumnsOrder, columns => columns);

const getMyTasksCalendarCollapsed = state => state?.myTasks?.calendarCollapsed || false;
export const makeGetMyTasksCalendarCollapsed = () => createSelector(getMyTasksCalendarCollapsed, columns => columns);

const getMyTasksHiddenColumns = state => state?.myTasks?.tasks?.hiddenColumns || DEFAULT_HIDDEN_COLUMNS;
export const makeGetMyTasksHiddenColumns = () => createSelector(getMyTasksHiddenColumns, hiddenColumns => hiddenColumns);

const getProjectCollapsedGroups = (state, projectId) => (state?.projects && state.projects[projectId]?.tasks?.collapsedGroups) || EMPTY_ARRAY;
export const makeGetProjectCollapsedGroups = () => createSelector(getProjectCollapsedGroups, collapsedGroups => collapsedGroups);

const getProjectHiddenColumns = (state, project) => (state?.projects && state.projects[project?.id]?.tasks?.hiddenColumns) || project?.hidden_list_columns || DEFAULT_HIDDEN_COLUMNS;
export const makeGetProjectHiddenColumns = () => createSelector(getProjectHiddenColumns, hiddenColumns => hiddenColumns);

const getProjectColumnsOrder = (state, project) => (state?.projects && state.projects[project?.id]?.tasks?.columns) || project?.list_columns_order || EMPTY_ARRAY;
export const makeGetProjectColumnsOrder = () => createSelector(getProjectColumnsOrder, columns => columns);
